import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, ChevronDown, User, Phone } from 'lucide-react';
import logo from '../asset/logo.png';


export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  const services = [
    { name: 'Web Development', path: '/services/web-development' },
    { name: 'Mobile Development', path: '/services/mobile-development' },
    { name: 'SEO & Marketing', path: '/services/seo-marketing' },
    { name: 'UI/UX Design', path: '/services/uiux-design' },
  ];

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'glass-effect shadow-lg' : 'bg-white/80 backdrop-blur-sm'
      }`}
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
         <Link
  to="/"
  className="h-19 w-auto object-contain mt-[1px]"
  data-testid="logo-link"
>
 <img
  src={logo}
  alt="CodeSky Logo"
  className="
    h-9 
    md:h-8
    w-auto 
    object-contain 
    mix-blend-multiply
  "
/>

</Link>

{/* DESKTOP NAVBAR */}
<div className="hidden lg:flex items-center w-full">

  {/* CENTER LINKS */}
  <div className="flex-1 flex justify-center items-center space-x-8">
    <Link to="/" className={`text-sm font-medium ${isActive('/') ? 'text-primary' : 'text-slate-700'}`}>
      Home
    </Link>

    <Link to="/about" className={`text-sm font-medium ${isActive('/about') ? 'text-primary' : 'text-slate-700'}`}>
      About
    </Link>

    {/* SERVICES */}
    <div
      className="relative"
      onMouseEnter={() => setServicesOpen(true)}
      onMouseLeave={() => setServicesOpen(false)}
    >
      <button className="flex items-center space-x-1 text-sm font-medium text-slate-700 hover:text-primary">
        <span>Services</span>
        <ChevronDown className="w-4 h-4" />
      </button>

      <AnimatePresence>
        {servicesOpen && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            className="absolute top-full left-0 mt-2 w-56 bg-white rounded-xl shadow-xl border py-2"
          >
            {services.map((service) => (
              <Link
                key={service.path}
                to={service.path}
                className="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 hover:text-primary"
              >
                {service.name}
              </Link>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>

    <Link to="/portfolio" className="text-sm font-medium text-slate-700 hover:text-primary">
      Portfolio
    </Link>

    <Link to="/careers" className="text-sm font-medium text-slate-700 hover:text-primary">
      Careers
    </Link>

    {/* <Link to="/blog" className="text-sm font-medium text-slate-700 hover:text-primary">
      Blog
    </Link> */}
  </div>

  {/* RIGHT ICONS */}
  <div className="flex items-center gap-7">
    <Link to="/admin/login" title="Admin Login">
      <User className="w-5 h-5 text-slate-700 hover:text-primary transition" />
    </Link>
    <Link to="/contact" title="Contact">
      <Phone className="w-5 h-5 text-slate-700 hover:text-primary transition" />
    </Link>
  </div>

</div>


          <button
            className="lg:hidden"
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-button"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              className="lg:hidden mt-4 pb-4 space-y-3"
            >
              <Link to="/" className="block py-2 text-slate-700 hover:text-primary" onClick={() => setIsOpen(false)}>
                Home
              </Link>
              <Link to="/about" className="block py-2 text-slate-700 hover:text-primary" onClick={() => setIsOpen(false)}>
                About
              </Link>
              <div className="space-y-2">
                <div className="py-2 text-slate-700 font-medium">Services</div>
                {services.map((service) => (
                  <Link
                    key={service.path}
                    to={service.path}
                    className="block py-2 pl-4 text-sm text-slate-600 hover:text-primary"
                    onClick={() => setIsOpen(false)}
                  >
                    {service.name}
                  </Link>
                ))}
              </div>
              <Link to="/portfolio" className="block py-2 text-slate-700 hover:text-primary" onClick={() => setIsOpen(false)}>
                Portfolio
              </Link>
              <Link to="/careers" className="block py-2 text-slate-700 hover:text-primary" onClick={() => setIsOpen(false)}>
                Careers
              </Link>
              {/* <Link to="/blog" className="block py-2 text-slate-700 hover:text-primary" onClick={() => setIsOpen(false)}>
                Blog
              </Link> */}
              {/* MOBILE ICON LINKS */}
              <div className="flex items-center gap-4 pt-2">
                <Link to="/admin/login" onClick={() => setIsOpen(false)} className="flex items-center gap-2">
                  <User className="w-5 h-5" /> Login
                </Link>
                <Link to="/contact" onClick={() => setIsOpen(false)} className="flex items-center gap-2">
                  <Phone className="w-5 h-5" /> Contact
                </Link>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </motion.nav>
  );
};

export default Navbar;
